import { render } from "./GaugeChart.vue?vue&type=template&id=8c3f40ec&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=ts"
export * from "./GaugeChart.vue?vue&type=script&lang=ts"

import "./GaugeChart.vue?vue&type=style&index=0&id=8c3f40ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c3f40ec"

export default script